import _get from 'lodash/get';
import { Task, useDashboardTaskShortQuery } from 'graphql-common';

type UseQueriesProps = {
  taskId?: string;
};

export default function useReporting(props: UseQueriesProps) {
  const { taskId = '' } = props;

  const taskQuery = useDashboardTaskShortQuery({
    variables: { id: taskId },
    skip: !taskId,
    fetchPolicy: 'network-only',
  });
  const taskData = _get(taskQuery, 'data.data') as Task;
  const taskLoading = _get(taskQuery, 'loading');
  const taskError = _get(taskQuery, 'error');

  return {
    taskData,
    taskError,
    taskLoading,
  };
}
